/**
 * xlsx-export helper — wraps SheetJS with a consistent header/styles preset
 * used by Sales, Purchases, and other register exports.
 */
import * as XLSX from "xlsx";

export function exportXlsx({ filename, sheetName, columns, rows, autoWidth = true }) {
  // columns: [{ key, label, format? }]
  const headerRow = columns.map((c) => c.label);
  const dataRows = rows.map((r) =>
    columns.map((c) => {
      const raw = r[c.key];
      if (raw === undefined || raw === null) return "";
      if (c.format === "date" && raw) {
        const d = new Date(raw);
        return isNaN(d.getTime()) ? String(raw) : d.toISOString().slice(0, 10);
      }
      return raw;
    })
  );
  const aoa = [headerRow, ...dataRows];
  const ws = XLSX.utils.aoa_to_sheet(aoa);

  if (autoWidth) {
    ws["!cols"] = columns.map((c) => {
      const maxLen = Math.max(
        c.label.length,
        ...rows.map((r) => String(r[c.key] ?? "").length)
      );
      return { wch: Math.min(Math.max(maxLen + 2, 10), 40) };
    });
  }

  // Freeze header row
  ws["!freeze"] = { xSplit: 0, ySplit: 1 };

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName || "Sheet1");
  XLSX.writeFile(wb, filename || `export_${Date.now()}.xlsx`);
}
